import React, { useState } from 'react'
import { Field } from 'redux-form'
import { CardElement } from '@stripe/react-stripe-js'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SettingsFormField from '../../Shared/Forms/SettingsFormField'
import { formatDate } from '../../../utils/datetime'
import { COUNTRY_CODES } from '../../../constants'
import {
  getAnnualToggle,
  getUpdateCardFlag,
  getUpdatePaymentSettingsFlag,
  setUpdateCardFlag,
  setAnnualFlag,
  getSubscription,
  getSelectedPlanValue,
  getPaymentRouteType,
  fetchCoupon,
} from '../../../ducks/trialWarning'
import { getOrganization } from '../../../ducks/organizations'
import WrappedNativeSelect from '../../Shared/Forms/WrappedNativeSelect'
import Button from '../../Shared/Button'

const PaymentForm = props => {
  const [couponVisible, setCouponVisible] = useState(false)
  const [coupon, setCoupon] = useState(null)
  const [couponError, setCouponError] = useState(null)
  const [couponSuccess, setCouponSuccess] = useState(false)
  const showCoupon = () => setCouponVisible(true)

  const COUNTRY_OPTIONS = COUNTRY_CODES.map(c => ({
    label: c.name,
    value: c.code,
  }))

  const {
    hideCoupon,
    annual,
    subscription = {},
    updateCardFlag,
    paymentRouteType,
    setUpdateCardFlag,
    setAnnualFlag,
    selectedPlanValue,
    updatePaymentSettings,
  } = props

  const updateCardFlagTrue = () => setUpdateCardFlag(true)
  const onToggle = () => setAnnualFlag(!annual)

  const getCoupon = async () => {
    setCoupon(null)
    setCouponError(null)
    setCouponSuccess(false)
    const { couponCode } = props

    const data = await fetchCoupon(couponCode)

    if (!data.error) {
      setCoupon(data)
      setCouponSuccess(true)

      return
    }

    const errorMessage = data?.error || 'An unknown error occurred'

    setCouponError(errorMessage)
  }

  const { planType } = subscription

  let { cardNumber = false, nextBillDate = false } = subscription

  let planName
  let initialPlanCost
  let planCost
  let yearlySavings
  let billingRecurrence

  if (annual) {
    billingRecurrence = 'yearly'

    if (selectedPlanValue === 'pro' || selectedPlanValue === 'individual') {
      planName = 'Pro Plan 12 Months'
      initialPlanCost = 600
      planCost = 468
      yearlySavings = '-$132'
    } else {
      planName = 'Business Plan 12 Months'
      initialPlanCost = 2400
      planCost = 1788
      yearlySavings = '-$612'
    }
  } else {
    billingRecurrence = 'monthly'

    if (selectedPlanValue === 'pro' || selectedPlanValue === 'individual') {
      planName = 'Monthly Pro Plan'
      initialPlanCost = 50
      planCost = 50
    } else {
      planName = 'Monthly Business Plan'
      initialPlanCost = 200
      planCost = 200
    }
  }

  let amountOff
  let nextBill = planCost

  if (coupon) {
    amountOff = coupon.percent_off
      ? planCost * (coupon.percent_off / 100)
      : coupon.amount_off / 100

    planCost = planCost - amountOff
    planCost = planCost.toFixed(2).replace('.00', '')
    amountOff = amountOff.toFixed(2).replace('.00', '')
    if (planCost < 0) planCost = 0

    nextBill = planCost

    if (coupon.duration !== 'forever') {
      if (coupon.duration_in_months) {
        if (
          coupon.duration_in_months <= 1 ||
          (coupon.duration_in_months <= 12 && annual)
        ) {
          nextBill = initialPlanCost
        }
      } else {
        nextBill = initialPlanCost
      }
    }
  }

  if (!nextBillDate) {
    if (billingRecurrence === 'yearly') {
      const nextYearDate = new Date().setFullYear(new Date().getFullYear() + 1)
      nextBillDate = moment(nextYearDate).format('M/DD/YYYY')
    } else {
      const nextMonthDate = new Date().setMonth(new Date().getMonth() + 1)
      nextBillDate = moment(nextMonthDate).format('M/DD/YYYY')
    }
  } else {
    nextBillDate = formatDate(nextBillDate)
  }

  let margin

  if (updatePaymentSettings) {
    margin = 'auto'
  }

  return (
    <div>
      {!updatePaymentSettings && (
        <div className="order-summary">
          <div className="order-summary-header">Order Summary</div>
          <div className="order-summary-content">
            <div className="left">{planName}</div>
            <div className="right">${initialPlanCost}</div>
            {annual ? (
              <>
                <div className="clear-left left">Yearly Savings</div>
                <div className="clear-right right">{yearlySavings}</div>
              </>
            ) : null}
            {amountOff ? (
              <>
                <div className="clear-left left">Promotion Savings</div>
                <div className="clear-right right">-${amountOff}</div>
              </>
            ) : null}
            <div className="clear-left">
              {!hideCoupon &&
                (couponVisible ? (
                  <div className="input-padding">
                    <Field
                      small
                      autoFocus
                      label="Discount Code"
                      name="coupon"
                      component={SettingsFormField}
                    />
                    <Button
                      className="team-settings-form-button"
                      type="button"
                      onClick={getCoupon}
                    >
                      Apply
                    </Button>
                  </div>
                ) : (
                  <a className="coupon-code-link" onClick={showCoupon}>
                    Have a Discount Code?
                  </a>
                ))}
              {couponError ? (
                <div className="coupon-code-error">{couponError}</div>
              ) : null}
              {couponSuccess ? (
                <div className="coupon-code-success">Coupon Applied!</div>
              ) : null}
            </div>
          </div>
          <div className="order-summary-footer">
            <div className="clear-left left">
              <h2>Today's Charge</h2>
            </div>
            <div className="clear-right right">
              <h2>${planCost}</h2>
            </div>
          </div>
          <div className="order-summary-plan-renewal">
            Your subscription is billed {billingRecurrence} and will
            automatically renew for ${nextBill} on {nextBillDate}
            <p> You can cancel any time before this date.</p>
          </div>
          {(paymentRouteType === 'upgrade' ||
            (selectedPlanValue && selectedPlanValue !== planType) ||
            (!selectedPlanValue && !hideCoupon)) && (
            <div>
              {annual ? (
                <a className="pay-monthly-btn" onClick={onToggle}>
                  No thanks, I'll pay the full monthly price
                </a>
              ) : (
                <a className="switch-to-yearly-btn" onClick={onToggle}>
                  SWITCH TO YEARLY SAVE 20%
                </a>
              )}
            </div>
          )}
        </div>
      )}

      {subscription &&
      cardNumber &&
      !updateCardFlag &&
      subscription.planType !== 'free' ? (
        <div className="payment-form payment-summary billing-payment-form">
          <div className="settings-form-row">
            <h2> Payment Details </h2>
            <div className="settings-form-input settings-stripe-input">
              Your Payment details Credit Card ending in ••••
              {cardNumber}
            </div>
            <div className="update-card-btn-wrapper">
              <a className="update-card-btn" onClick={updateCardFlagTrue}>
                Update card
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="billing-payment-form payment-form"
          style={{
            margin,
          }}
        >
          <div className="settings-form-row">
            <h2> Payment Details </h2>
            <label>Credit or Debit Card</label>
            <div className="settings-form-input settings-stripe-input">
              <CardElement options={{ hidePostalCode: true }} />
            </div>
          </div>
          <Field
            small
            label="Name on Card"
            name="name"
            component={SettingsFormField}
          />
          <h2> Billing Details </h2>
          <div className="payment-form-country-input">
            <Field
              small
              displayName="Country of billing address"
              name="address_country"
              options={COUNTRY_OPTIONS}
              component={WrappedNativeSelect}
              label="Country of billing address"
            />
          </div>

          <Field
            small
            label="Street Address"
            name="address_line1"
            component={SettingsFormField}
          />
          <Field
            small
            label="City"
            name="address_city"
            component={SettingsFormField}
          />
          <Field
            small
            label="Postal Code"
            name="address_zip"
            component={SettingsFormField}
          />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state, { organizationId }) => {
  return {
    updateCardFlag: getUpdateCardFlag(state),
    hideCoupon: getUpdatePaymentSettingsFlag(state),
    annual: getAnnualToggle(state),
    subscription: getSubscription(
      state,
      getOrganization(state, organizationId)
    ),
    selectedPlanValue: getSelectedPlanValue(state),
    paymentRouteType: getPaymentRouteType(state),
    updatePaymentSettings: getUpdatePaymentSettingsFlag(state),
  }
}

const connected = connect(mapStateToProps, {
  setUpdateCardFlag,
  setAnnualFlag,
})(PaymentForm)

export default withRouter(connected)
